import { render, staticRenderFns } from "./AufgabenComponentIndexMainTable.vue?vue&type=template&id=b64eb060&scoped=true"
import script from "./AufgabenComponentIndexMainTable.vue?vue&type=script&lang=js"
export * from "./AufgabenComponentIndexMainTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b64eb060",
  null
  
)

export default component.exports